import { Flex } from 'foundations-components/components/Flex';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { IntersectionObserver } from 'foundations-components/transitional/components/IntersectionObserver';
import { isCanvasTheme, useTheme } from 'foundations-theming/utils';
import { useCallback, useRef } from 'react';
import ComposableBlocks from './ComposableBlocks';
import ComposableCardHeader from './ComposableCardHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ComposableCardSectionFormatter = ({
  section,
  message,
  callbacks
}) => {
  const {
    headerBlocks,
    bodyBlocks,
    title
  } = section;
  const theme = useTheme();
  const isCanvas = isCanvasTheme(theme);
  const hasTrackedImpressionRef = useRef(false);
  const handleIntersectionChange = useCallback(({
    entries
  }) => {
    const isIntersecting = entries.some(entry => entry.isIntersecting);
    if (isIntersecting && !hasTrackedImpressionRef.current) {
      var _callbacks$COMPOSABLE, _callbacks$COMPOSABLE2;
      hasTrackedImpressionRef.current = true;
      callbacks === null || callbacks === void 0 || (_callbacks$COMPOSABLE = callbacks.COMPOSABLE_CARD) === null || _callbacks$COMPOSABLE === void 0 || (_callbacks$COMPOSABLE2 = _callbacks$COMPOSABLE.onViewImpression) === null || _callbacks$COMPOSABLE2 === void 0 || _callbacks$COMPOSABLE2.call(_callbacks$COMPOSABLE, section.id);
    }
  }, [callbacks, section.id]);
  return /*#__PURE__*/_jsx(IntersectionObserver, {
    onIntersectionChange: handleIntersectionChange,
    renderContent: () => /*#__PURE__*/_jsx(CardWrapper, {
      compact: true,
      marginBlock: "400",
      borderRadius: isCanvas ? '300' : undefined,
      borderWidth: isCanvas ? '100' : undefined,
      borderStyle: isCanvas ? 'solid' : undefined,
      borderColor: isCanvas ? 'border-core-subtle' : undefined,
      children: /*#__PURE__*/_jsxs(CardSection, {
        flexDirection: "column",
        padding: "400",
        children: [/*#__PURE__*/_jsx(ComposableCardHeader, {
          blocks: headerBlocks,
          fallbackTitle: title,
          callbacks: callbacks
        }), /*#__PURE__*/_jsx(Flex, {
          flexDirection: "column",
          gap: "300",
          children: /*#__PURE__*/_jsx(ComposableBlocks, {
            blocks: bodyBlocks,
            message: message,
            callbacks: callbacks,
            sectionId: section.id
          })
        })]
      })
    })
  });
};
export default ComposableCardSectionFormatter;